import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-priv-audio',
  templateUrl: './priv-audio.component.html',
  styleUrls: ['./priv-audio.component.css']
})
export class PrivAudioComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit() {
  }

  fnNavegar(pagina){
    if(pagina=="PRIV")
      this.router.navigate(['privacidad']);
  }

}
